<template>
  <div
    class="flex-middle flex-center padding-max-block flex-column gap-2xl padding-xl-horizontal"
    style="height: 100vh; height: 100lvh">
    <img
      :src="getDynamicAssetUrl('core/images/logos/main.png')"
      :alt="t('core.genericAlt.imageOf', { thing: t('core.meta.siteName') })"
      class="logo max-width-400"
      style="max-height: 250px" />
    <h1>{{ t("core.meta.siteName") }}</h1>
    <div
      class="flex-center bg-gray-2 padding-m fixed-bottom-strip"
      v-if="$store.getters['user/isLoggedIn']">


      <div class="container flex-middle flex-center gap-m">
        <span>{{tu('core.heyUser', {name:$store.getters['user/profile']?.firstName})}}</span>
        <form-button
          size="s"
          icon="arrow-logout-right"
          theme="inverse"
          text="core.user.logout"
          @click="$store.dispatch('user/logout')"></form-button>
      </div>
    </div>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";

export default {
  components: {},
  setup(props) {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  layout: "default",
  meta: {
    title: "core.defaultPage.mainTitle",
    descriptions: "core.defaultPage.metaDescription",
  },
  data() {
    return {
      homepageData: false,
      appName: process.env.VUE_APP_APPLICATION_NAME,
      asyncData: {},
    };
  },
  computed: {},
};
</script>

<style lang="scss" scoped></style>
